import { Component, PropsWithChildren } from 'react';

import { getErrorMessage } from 'utils/error';

import { ErrorBoundaryView } from './view';

export class ErrorBoundary extends Component<
  PropsWithChildren,
  { error: string | null; dynamicImportError?: boolean }
> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: unknown) {
    const errorMessage = getErrorMessage(error);

    if (
      errorMessage.startsWith('Failed to fetch dynamically imported module')
    ) {
      return {
        error: errorMessage,
        dynamicImportError: true,
      };
    }

    return { error: errorMessage };
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorBoundaryView
          error={this.state.error}
          dynamicImportError={this.state.dynamicImportError}
        />
      );
    }

    return this.props.children;
  }
}
